/**
 * ProShip Direct v2 — feature gate and route prefix.
 *
 * Lives behind its own env flag so this module and Ashvini's `direct/` module can be on
 * independently: turn both on to compare them side by side, or either one alone to demo it.
 * Set REACT_APP_DIRECT_PLAN in .env.local — never in .env, which is committed and would
 * change every build.
 *
 * ROUTE_PREFIX is deliberately a single constant. Ashvini's module is scheduled for removal
 * after sign-off, at which point this module is promoted onto /direct/* — with the prefix
 * held here that promotion is a one-line change instead of a find-and-replace across the
 * route table and every internal link.
 */

export const ROUTE_PREFIX = '/dp';

/** Build a module route: dpPath('/home') → '/dp/home' */
export const dpPath = (suffix) => `${ROUTE_PREFIX}${suffix}`;

export const isDirectPlanEnabled = () => process.env.REACT_APP_DIRECT_PLAN === 'true';

/**
 * Settings modules that are NOT part of the Direct plan, and no longer live under /dp.
 *
 * Couriers, rules, priority, PACE, labels and returns QC are platform settings: they apply to
 * every shipment a merchant sends, on ProShip couriers or their own, whether or not a Direct
 * plan is active. Parking them under /dp said the opposite — that they belonged to one paid
 * module — and a merchant without that plan would reasonably read the URL as "not for me".
 *
 * dpPath() still owns the pages that really are the plan: Home, My Couriers, Courier Setup and
 * Direct Performance. Those are meaningless without a subscription; these are not.
 *
 * A MAP, NOT LITERALS AT EACH CALL SITE. Twenty-two links point at these seven pages. The last
 * move was a find-and-replace across five files; the next one is an edit here.
 */
export const SETTINGS_PATHS = {
  manageCouriers: '/manage-couriers',
  rules: '/courier-rules',
  /* A child of the rules list, and pathed as one — it is only ever entered from there. */
  ruleBuilder: '/courier-rules/builder',
  priority: '/courier-priority',
  pace: '/pace-engine',
  labelConfig: '/label-config',
  returnsQc: '/returns-qc',
};
